module.exports = __webpack_public_path__ + "static/media/php.3ad42217.png";